import React from 'react'

const TabContainer = (props) => <div>{props.children}</div>

export default TabContainer
